import ApiService from '@/services/api.service'

export async function getFullManagementResponse() {
    let response = await ApiService.get("management/full");
    return response.data;
}